import { render, staticRenderFns } from "./goodsStyle.vue?vue&type=template&id=e7fe7862&scoped=true&"
import script from "./goodsStyle.vue?vue&type=script&lang=js&"
export * from "./goodsStyle.vue?vue&type=script&lang=js&"
import style0 from "./goodsStyle.vue?vue&type=style&index=0&id=e7fe7862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fe7862",
  null
  
)

export default component.exports